export const scrollToFirstDangerElement = (retryNr: number) => {
  var elementList = document.getElementsByClassName('help is-danger')
  if (elementList.length) elementList[0]?.parentElement?.scrollIntoView({ block: 'center', behavior: 'smooth' })
  else if (retryNr < 8) delayScrollToFirstDangerElement(retryNr + 1)
}

export const delayScrollToFirstDangerElement = (retryNr = 0) => {
  setTimeout(() => scrollToFirstDangerElement(retryNr), 250)
}

export const scrollToElement = (elementId: string) => {
  document.getElementById(elementId)?.scrollIntoView(true)
}

export const scrollToElementAlignBottom = (elementId: string, time: number = 100) => {
  setTimeout(() => {
    document.getElementById(elementId)?.scrollIntoView({ block: 'end', inline: 'nearest', behavior: 'smooth' })
  }, time)
}

export const scrollToTop = () => {
  scrollTo({ top: 0, behavior: 'smooth' })
}
